module.exports = __webpack_public_path__ + "img/mq_bg.8fb06173.svg";